import { matchPath } from 'react-router-dom'
import { OUT_OF_FLOW_PATHS, OVERVIEW_PATHS } from './routeRegistry'
import type { ResolvedWorkflowStep, WorkflowDefinition, WorkflowStep } from './types'

function normalizePath(pathname: string): string {
  if (!pathname || pathname === '/') return '/'
  return pathname.endsWith('/') && pathname.length > 1 ? pathname.slice(0, -1) : pathname
}

function matchStepForPath(definition: WorkflowDefinition, pathname: string): WorkflowStep | null {
  const normalized = normalizePath(pathname)
  for (const step of definition.steps) {
    for (const pattern of step.routePatterns) {
      if (matchPath({ path: pattern, end: true }, normalized)) {
        return step
      }
    }
  }
  return null
}

export function resolveWorkflowStep(
  definition: WorkflowDefinition,
  pathname: string,
): ResolvedWorkflowStep | null {
  const normalized = normalizePath(pathname)
  if (OUT_OF_FLOW_PATHS.has(normalized)) return null

  const step = matchStepForPath(definition, normalized)
  if (!step) return null

  const index = definition.steps.findIndex((s) => s.key === step.key)
  if (index < 0) return null
  return { step, index }
}

/** Whether pathname participates in the compliance trail (overview or matched step). */
export function isWorkflowInFlowForDefinition(
  definition: import('./types').WorkflowDefinition,
  pathname: string,
): boolean {
  const normalized = normalizePath(pathname)
  if (OUT_OF_FLOW_PATHS.has(normalized)) return false
  if (OVERVIEW_PATHS.has(normalized)) return true
  return resolveWorkflowStep(definition, pathname) != null
}

export function isWorkflowOverview(pathname: string): boolean {
  return OVERVIEW_PATHS.has(normalizePath(pathname))
}
